import React, {Component} from "react"
import styles from "./UsersPage.scss"
import {_getListUsers} from "../../../../../services/apis/AdminServices"
import UserItem from "../UserItem/UserItem"
import {_getTotalUsers} from "../../../../../services/apis/AdminUserServices"
import FormSearchUsers from "../FormSearchUsers/FormSearchUsers"
import UserPagination from "../UserPagination/UserPagination"
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"


const getInitPage = () => {
    const parsedQuery = parseSearchQuery();
    return !!parsedQuery.page ? parseInt(parsedQuery.page, 10) : 1
}

class UsersPage extends Component {
    state = {
        query: {},
        users: [],
        total: 0,
        pagination: {
            page: getInitPage(),
            pages: 1,
            limit: 100,
        },
        needFetch: false
    }

    componentDidMount() {
        this._fetchListUsers()
        this._fetchTotalUsers()
    }

    componentDidUpdate(prevProps, prevState) {
        const {pagination} = this.state
        const currentPage = pagination.page

        if (this.state.needFetch) {
            return this._fetchListUsers()
        }

        if (prevState.pagination && prevState.pagination.page !== currentPage) {
            this._fetchListUsers()
        }
    }

    _fetchListUsers = () => {
        const {query, pagination} = this.state
        const {page, limit} = pagination

        this.setState({
            needFetch: false
        })

        return _getListUsers({query, page, limit})
            .then(response => {
                const {success, data} = response

                if (success) {
                    const {page, pages, limit, total, docs} = data

                    this.setState({
                        users: docs,
                        total,
                        pagination: {
                            page,
                            pages,
                            limit
                        }
                    })
                }
            })
    }

    _fetchTotalUsers = () => {
        return _getTotalUsers()
            .then(result => {
                const {success, data} = result

                if (success) {
                    this.setState({
                        total: data
                    })
                }
            })
    }

    _handleChangeQuery = (query) => {
        this.setState(({pagination}) => ({
            needFetch: true,
            query,
            pagination: {
                ...pagination,
                page: 1
            }
        }))
    }

    _handleChangePage = (page) => {
        changeQuerySearch({page})
        this.setState(({pagination}) => ({
            needFetch: true,
            pagination: {
                ...pagination,
                page: parseInt(page, 10)
            }
        }))
    }

    render() {
        const {users, total, pagination} = this.state
        const {page, pages, limit} = pagination

        return (
            <div className={styles.page}>
                <h1>Users ({total})</h1>

                <FormSearchUsers onChangeQuery={this._handleChangeQuery}/>

                <table className="table">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Subscription</th>
                        <th>Notes</th>
                        <th>IP</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        users.map((user, index) => {
                            const order = (page - 1) * limit + index + 1

                            return <UserItem order={order} key={user._id} data={user}/>
                        })
                    }
                    </tbody>
                </table>

                <UserPagination page={page} pages={pages} onChangePage={this._handleChangePage}/>
            </div>
        )
    }
}

export default UsersPage



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/users/UsersPage/UsersPage.js